import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ENVIRONMENT_CONFIG } from '@movinmotion/conf-shared';

@Injectable()
export class WithCredentialsInterceptor implements HttpInterceptor {
  private readonly environment = inject(ENVIRONMENT_CONFIG);
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.url.startsWith(this.environment.api.movinmotionBackend)) {
      return next.handle(req.clone({ withCredentials: true }));
    }
    return next.handle(req);
  }
}
